import { IFormGroup } from "../../Interface/IFormGroup";
import {
	Agency,
	Channels,
	OfficeLocation,
	HubLocation,
	WorkForActivation,
	WorkForHub
} from "./FormElements";


export const ProfileGroup: IFormGroup = {
	id: "profilegroup",
	elements: [
		Agency,
		OfficeLocation,
		WorkForActivation,
		Channels,
		WorkForHub,
		HubLocation,
	],
	isVisible: true,
	title: ""
};